export default __webpack_public_path__ + "static/media/22.ed08344b.jpg";